// PVWatts V5 / pvlib inverter.pvwatts. Euro loads are AC output / rated AC.
// Solving output(load) first avoids treating an AC-load chart as DC loading.
const REF = 0.9637;
export const EURO_WEIGHTS = [[0.05,0.03],[0.1,0.06],[0.2,0.13],[0.3,0.1],[0.5,0.48],[1,0.2]];
export const pvwattsShape = z => (-0.0162*z - 0.0059/z + 0.9858)/REF;
export function dcLoadAtAcLoad(load) {
  const c = 0.0059 + REF*load;
  return 2*c/(0.9858 + Math.sqrt(0.9858**2 - 4*0.0162*c));
}
export const EURO_FACTOR = EURO_WEIGHTS.reduce((sum,[load,weight])=>sum+weight*load/dcLoadAtAcLoad(load),0);
export const PEAK_FACTOR = pvwattsShape(Math.sqrt(0.0059/0.0162));
const numeric = value => value == null || String(value).trim()==='' ? NaN : Number(String(value).replace(',','.'));
export function pvwattsFromEuro({ euro, max, respectMax = true }, paco) {
  const target=numeric(euro), maximum=numeric(max), power=numeric(paco);
  const hasMax=max != null && String(max).trim()!=='';
  if (!(target>0 && target<=1)) return {error:'euro'};
  if (hasMax && !(maximum>0 && maximum<=1)) return {error:'max'};
  if (hasMax && target>maximum) return {error:'inconsistent'};
  const requestedNominal=target/EURO_FACTOR;
  const nominal=hasMax && respectMax ? Math.min(requestedNominal, maximum/PEAK_FACTOR) : requestedNominal;
  const peak=nominal*PEAK_FACTOR;
  if (peak>1+1e-12) return {error:'physical'};
  const achieved=nominal*EURO_FACTOR;
  const points=Array.from({length:200},(_,i)=>{
    const load=(i+1)/200;
    return {load:load*100,efficiency:100*nominal*load/dcLoadAtAcLoad(load)};
  });
  return { nominal, peak, achieved, target, maximum:hasMax?maximum:null,
    constrained:nominal<requestedNominal-1e-12, points,
    characteristics: power>0 && Number.isFinite(power) ? {
      Pdco:power/nominal, eff_nom:nominal, eff_max:peak,
      pvwatts_efficiency_source:'euro_ac_v1', pvwatts_euro_target:target,
      pvwatts_euro_achieved:achieved, pvwatts_manufacturer_max:hasMax?maximum:null,
      pvwatts_respect_max:Boolean(respectMax),
    } : null };
}
